<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        lg="12"
        class="loading-container"
      >
        <b-spinner
          variant="light"
          label="Loading..."
        />
        <span class="loading-text">กำลังโหลดวิดีโอ...</span>
      </b-col>

      <b-col
        v-else-if="error"
        lg="12"
        class="error-container"
      >
        {{ error }}
        <b-button
          size="sm"
          variant="outline-light"
          @click="getRTSPCCTV"
        >
          ลองใหม่
        </b-button>
      </b-col>

      <template v-else>
        <b-col
          v-for="(link, index) in rtspData"
          :key="index"
          :lg="rtspData.length >= 3 ? '6' : '12'"
          md="12"
          sm="12"
        >
          <br>
          <b-card>
            <b-link
              v-b-modal="'Live1'"
              @click="openVideoStream(link.RTSP_HLS, index)"
            >
              <VideoPlayer
                :source="link.RTSP_HLS"
                :index="index"
              />
            </b-link>
          </b-card>
        </b-col>
      </template>
    </b-row>

    <Live ref="RTSP" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BLink,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import Live from './LiveRTSP.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
  name: 'WIMRTSP',

  components: {
    BRow,
    BCol,
    BCard,
    BLink,
    BSpinner,
    BButton,
    Live,
    VideoPlayer,
  },

  data() {
    return {
      loading: false,
      error: null,
      interval: null,
      rtsp: [],
      name: [],
      rtspData: [],
      ISOnline: [],
      poster: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },

  mounted() {
    this.initializeRTSP()
  },

  beforeDestroy() {
    this.clearInterval()
  },

  methods: {
    initializeRTSP() {
      this.getRTSPCCTV()
      this.startInterval()
    },

    startInterval() {
      this.clearInterval()
      this.interval = setInterval(() => {
        this.getRTSPCCTV()
      }, 600000) // 10 minutes
    },

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    async getRTSPCCTV() {
      if (this.loading) return

      this.loading = true
      this.error = null

      try {
        const response = await axios.post(
          'https://wts.drr.go.th/node-red/get-CCTV-WIM',
          { wid: this.$route.query.wid },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            timeout: 10000,
          },
        )

        // Clear existing data
        this.rtspData = []
        this.rtsp = []
        this.name = []

        // Update with new data
        this.rtspData = response.data
      } catch (error) {
        console.error('Error loading RTSP data:', error)
        this.error = 'ไม่สามารถโหลดข้อมูลวิดีโอได้'
        setTimeout(() => {
          this.getRTSPCCTV()
        }, 30000)
      } finally {
        this.loading = false
      }
    },

    // eslint-disable-next-line no-unused-vars
    openVideoStream(rtspUrl, index) {
      try {
        this.$refs.RTSP.streamLive(rtspUrl)
      } catch (error) {
        console.error('Error opening video stream:', error)
      }
    },
  },
}
</script>

 <style scoped>
 .loading-container,
 .error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #fff;
  gap: 1rem;
 }

 .loading-text {
  margin-top: 0.5rem;
 }

 .video-container {
  position: relative;
  width: 100%;
  margin-top: 1rem;
 }

 .offline-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 1.2rem;
 }
 </style>
